import { render, staticRenderFns } from "./CalendarAddEvent.vue?vue&type=template&id=5f2b27e0&"
import script from "./CalendarAddEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarAddEvent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAddEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports